ds-text {
  & > span,
  & > p,
  & > strong {
    font-size: inherit;
    color: inherit;
    line-height: inherit;
    padding: 0;
    margin: 0;
  }

  &[tag="p"] {
    display: block;
  }
}